<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="d-flex ma-3 justify-space-between">
        <div class="d-flex">
          <div class="topic_breadcrumb_header border_right">รายการสินค้า/บริการ</div>
          <div class="topic_breadcrumb_content ma-2">ระบบ POS</div>
          <div class="topic_breadcrumb_content ma-2"> > </div>
          <div class="topic_breadcrumb_content ma-2">คลังสินค้า</div>
          <div class="topic_breadcrumb_content ma-2"> > </div>
          <div class="topic_breadcrumb_content ma-2">รายการสินค้า/บริการ</div>
        </div>
        <div>
          <div class="mt-n2">
            <div class="text-center mt-n2">
              <v-btn height="45" @click="product_modal = true" class="white--text grad-success-arin-bg" style="font-size: 18px; border-radius: 10px;">เพิ่มสินค้า</v-btn>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-5">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <div class="d-flex justify-end">
            <div class="mt-1">
              <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined></v-text-field>
            </div>
          </div>
          <div class="d-flex justify-start">
            <div class="mt-1">
              <v-autocomplete no-data-text="ไม่พบข้อมูลที่ค้นหา" clearable color="#84611F" class="input-radius" :items="action_list" item-text="name" item-value="id" v-model="action_id" placeholder="เลือก Action สินค้าที่เลือก" hide-details="auto" outlined></v-autocomplete>
            </div>
          </div>
          <div class="ma-3">
            <v-data-table show-select v-model="selected" :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td><v-checkbox color="#D6BFAF" v-model="selected" :value="item"/></td>
                    <td>
                      <div>{{item.product_code}}</div>
                    </td>
                    <td>
                      <div>{{item.product_name}}</div>
                    </td>
                    <td>
                      <div>{{item.name_sci}}</div>
                    </td>
                    <td>
                      <div>{{item.product_type}}</div>
                    </td>
                    <td>
                      <div class="d-flex justify-center"><v-switch color="#D6BFAF" v-model="item.status"></v-switch></div>
                    </td>
                    <td>
                      <div class="pa-2">
                        <v-btn elevation="3" class="ma-2" @click="detail_product(item.id)" outlined small height="45" color="#8EBBDC" style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn elevation="3" class="ma-2" @click="edit_product(item.id)" outlined small height="45" color="#FEA06C" style="border-radius: 10px;background-color: #FFFFFF" title="แก้ไขรายละเอียด">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn elevation="3" class="ma-2" outlined small height="45" color="#F28080" style="border-radius: 10px;background-color: #FFFFFF" title="ลบข้อมูล">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td>
                      <div class="pa-2">
                        <v-btn elevation="3" outlined small height="45" color="#88B358" style="border-radius: 10px;background-color: #FFFFFF" title="ลบข้อมูล">
                          ตั้งราคา
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </section>
      <v-dialog v-model="product_modal" persistent max-width="520">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              การเพิ่มข้อมูลสินค้า
            </v-card-title>
            <v-btn icon class="ma-4" @click="product_modal = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="text-center">กรุณาเลือกการเพิ่มข้อมูลสินค้า</div>
          <div class="grid_half">
            <v-card elevation="3" class="card_modal ma-5 mr-0 pa-3">
              <v-img height="47" max-width="47" :lazy-src="img_upload" :src="img_upload" class="preview"></v-img>
              <div class="text-center grey--text">เลือกดึง</div>
              <div class="text-center grey--text">ชุดข้อมูลสินค้า</div>
            </v-card>
            <v-card elevation="3" @click="confirm_redirect" class="card_modal ma-5 ml-0 pa-3">
              <v-img height="47" max-width="47" :lazy-src="img_package" :src="img_package" class="preview"></v-img>
              <div class="text-center grey--text">เพิ่ม</div>
              <div class="text-center grey--text">ข้อมูลสินค้า</div>
            </v-card>
          </div>
          <v-spacer></v-spacer>
          <div class="text-center py-4">
            <v-btn height="45" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">ยืนยัน</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import img_upload from "@/assets/arin_assets/uploading.png";
import img_package from "@/assets/arin_assets/add-package.png";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_manage_service",
  data() {
    return {
      loading_page: false,
      product_modal: false,
      search: '',
      action_id: '',
      img_upload: img_upload,
      img_package: img_package,
      selected: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      action_list: [
        {id: 1, name: 'A'},
        {id: 2, name: 'B'},
        {id: 3, name: 'C'},
        {id: 4, name: 'D'},
        {id: 5, name: 'E'},
      ],
      headers: [
        {
          text: 'รหัสสินค้า',
          value: '',
          fixed: true,
          width: '120px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อสินค้า',
          value: '',
          fixed: true,
          width: '200px',
          align: 'left',
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: '',
          fixed: true,
          width: '180px',
          align: 'left',
        },
        {
          text: 'ประเภท',
          value: '',
          fixed: true,
          width: '120px',
          align: 'left',
        },
        {
          text: 'สถานะ',
          value: '',
          fixed: true,
          width: '120px',
          align: 'center',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          width: '160px',
          align: 'left',
        },
        {
          text: 'ตั้งราคา',
          value: '',
          fixed: true,
          width: '60px',
          sortable: false,
          align: 'left',
        },
      ],
      data_list: [
        {
          id: 1,
          product_code: 'ANB0015',
          product_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          name_sci: '-',
          product_type: 'ยาคลินิก',
          status: true,
        },
        {
          id: 2,
          product_code: 'BER3029',
          product_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
          name_sci: 'carvedilol',
          product_type: 'ยาคลินิก',
          status: true,
        },
        {
          id: 3,
          product_code: 'PRO-007',
          product_name: 'wt.น้ำกลั่นปราศจากเชื้อ ANB 1000 ML. **ฝาฟ้า 55.-',
          name_sci: 'sterile water',
          product_type: 'ผลิตภัณฑ์เพื่อสุขภาพ',
          status: true,
        },
      ],
    }
  },
  methods: {
    confirm_redirect() {
      this.product_modal = false
      this.$router.push('/arin/pos/addproductservice')
    },
    detail_product(id) {
      this.$router.push('/arin/pos/detailproductdata/' + id)
    },
    edit_product(id) {
      this.$router.push('/arin/pos/editproductservice/' + id)
    },
  },
}
</script>

<style scoped>
.input-radius {
  border-radius: 10px;
}
.mobile_btn {
  width: 30%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.card_modal {
  border: 1px solid #ADADAD;
  border-radius: 10px;
}
.preview {
  border-radius: 10px;
  margin: auto;
}
</style>
